<div class="sms-row">
    <div [ngClass]="{'sms-send' : message.status == 'send', 'sms-received' : message.status != 'send', 'sms-none' : message.status == 'none', 'sms-failed' : message.status == 'failed'}">
        <div class="sms-users">
            {{ message?.sender }} -> {{ message?.receiver }}
        </div>
        <div class="sms-content">{{ message?.text }}</div>
        <div class="sms-date">
            {{ message?.dateAsString }}
        </div>
    </div>
</div>